// Ignite Product Card - Add to Cart Handler
// This script handles add to cart functionality for Ignite product cards

(function() {
  'use strict';

  // Only initialize once
  if (window.igniteCardHandlerInitialized) {
    return;
  }

  function initIgniteCardHandler() {
    // Use event delegation on document to handle all card buttons
    document.addEventListener('click', function(evt) {
      const button = evt.target.closest('.ignite-card__add-btn');
      if (!button) return;

      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
      
      if (button.disabled || button.classList.contains('loading')) {
        return false;
      }
      
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('No variant ID found on button');
        return false;
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      button.classList.add('loading');
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.section || section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Cart error:', response);
            return;
          } else if (!cart) {
            window.location = window.Shopify.routes.root + 'cart';
            return;
          }

          // Render cart contents and open drawer
          cart.renderContents(response);
        })
        .catch((e) => {
          console.error('Add to cart error:', e);
        })
        .finally(() => {
          button.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        });
      
      return false;
    }, true); // Use capture phase to catch events early

    window.igniteCardHandlerInitialized = true;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIgniteCardHandler);
  } else {
    // DOM is already ready
    initIgniteCardHandler();
  }
})();
